import React, { useState, useEffect } from 'react';
import ModelDetailsSectionTitle from './ModelDetailsSectionTitle';
import ModelDetailsQualityBenchmarksTable from './ModelDetailsQualityBenchmarksTable';

export default function ModelDetailsBenchmarksTab({
  benchmarksEntries = [],
  taskType,
  onDownload,
  /** Distillation event id of the benchmark currently displayed on the main Evaluation page. */
  selectedBenchmarkEventId = null,
  /** Notifies the parent (Evaluation page) when the user picks a different benchmark row. */
  onSelectBenchmark,
}) {
  const entries = Array.isArray(benchmarksEntries) ? benchmarksEntries : [];
  // Default the highlighted row to whatever the main page is currently showing,
  // so opening the drawer never desyncs the highlight from the active run.
  const [selectedRowKey, setSelectedRowKey] = useState(selectedBenchmarkEventId);

  useEffect(() => {
    if (entries.length === 0) return;
    const keys = new Set(entries.map((e) => e.distillation_event_id));
    const externallySelectedExists =
      selectedBenchmarkEventId && keys.has(selectedBenchmarkEventId);
    if (externallySelectedExists && selectedRowKey !== selectedBenchmarkEventId) {
      setSelectedRowKey(selectedBenchmarkEventId);
      return;
    }
    if (selectedRowKey == null || !keys.has(selectedRowKey)) {
      setSelectedRowKey(externallySelectedExists ? selectedBenchmarkEventId : entries[0].distillation_event_id);
    }
  }, [entries, selectedRowKey, selectedBenchmarkEventId]);

  const handleSelectRow = (record) => {
    const nextId = record?.distillation_event_id ?? null;
    setSelectedRowKey(nextId);
    if (typeof onSelectBenchmark === 'function' && nextId) {
      onSelectBenchmark(nextId);
    }
  };

  return (
    <div>
      <ModelDetailsSectionTitle title="Quality Benchmarks" />
      <ModelDetailsQualityBenchmarksTable
        entries={entries}
        taskType={taskType}
        selectedRowKey={selectedRowKey}
        onSelectRow={handleSelectRow}
        onDownload={onDownload}
      />
    </div>
  );
}
